<template>
    <div class="chart">
        <div class="bar" v-for="(item, index) in value" :key="index" >
            <div class="label" style="height:130px" @click="selectMunicipality(item)"><div style="height:60px;display:flex;justify-content:center;flex-direction:column">{{ item.label }}</div><hr/><span style="color: #000000">{{item.percentage}}%</span><hr/><img :src="item.logo" style="height:50px;width:100%;object-fit:contain"/></div>
            <div class="bar-visual"
                 :style="{ height: 'calc('+item.percentage + '% + 30px)' }" @click="selectMunicipality(item)"></div>
            <div class="value" @click="selectMunicipality(item)">{{ (item.value!='0'?item.value:'') }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BarChart',
        props:{        
            value: {
                type: Array,
                default: () => [],
            },
        },
        methods: {
            selectMunicipality(municipality) {
                this.$emit('selectMunicipality', municipality)
            }
        }
    }
</script>

<style scoped>
    .chart {
        display: flex;
        align-items: flex-end; /* Align bars to the bottom of the container */
        justify-content: center;
        gap: 10px;
        height: 400px;
        padding: 20px;
        padding-bottom:130px;
    }

    .bar {
        display: flex;
        flex-direction: column-reverse; /* Reverse stacking order to make bars grow from bottom */
        align-items: center;
        width: 5%;
        text-align: center;
        height:100%;
        position:relative
    }

        .bar .value {
            margin-bottom: 8px;
            font-size: 14px;
            font-weight: bold;
            color: #000
        }

        .bar .bar-visual {
            width: 100%;
            background-color: #00bcd4;
            border-radius: 4px;
            transition: height 0.3s ease-in-out;
        }

        .bar .label {
            margin-top: 8px;
            font-size: 12px;
            color: #000;
            position: absolute;
            margin-bottom: -130px;
        }

    @media screen and (max-width: 768px) {
        .chart {
            flex-wrap: wrap;
            height: auto;
        }

        .bar {
            width: 18%;
            margin-bottom: 20px;
        }
    }
</style>
